<script setup lang="ts">
interface Locale {
  code: string;
  region: string;
  name: string;
}

defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const { locales, setLocale, locale } = useI18n();

const sortedLocales = computed<Locale[]>(() => {
  return (locales.value as unknown as Locale[])
    .map((l: Locale) => ({
      code: l.code,
      name: l.name,
      region: l.region,
    }))
    .sort((a: Locale, b: Locale) => a.code.localeCompare(b.code));
});

function onLanguageSelect(code: typeof locale) {
  setLocale(code);
  emit('close');
}
</script>
<template>
  <ul class="flex flex-col content-end gap-[2rem]">
    <li v-for="(l, index) in sortedLocales" :key="index" class="text-right cursor-pointer" @click="onLanguageSelect(l.code as typeof locale)">
      <b>{{ l.name }}</b>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.language-button {
  display: block;
  height: auto;
  width: 100%;
}
.locale-list {
  @media (max-width: 1024px) {
    gap: 2rem;
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    gap: 2rem;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
